import { create } from "zustand";
import { ToDo, TripX } from "@/types";
import { Friend } from "@/types/social";

interface TripTodosMap {
  [tripId: string]: ToDo[];
}

export interface LodgeState {
  trips: TripX[];
  selectedTrip: TripX | null;
  friends: Friend[];
  tripTodos: TripTodosMap;
  setFriends: (friends: Friend[]) => void;
  setSelectedTrip: (trip: TripX | null) => void;
  addTodo: (tripId: string, todo: ToDo) => void;
  toggleTodoComplete: (tripId: string, todoId: number) => void;
  deleteTodo: (tripId: string, todoId: number) => void;
  updateTodoId: (tripId: string, oldId: number, newId: number) => void;
  setTrips: (trips: TripX[]) => void;
  initializeTripTodos: (trips: TripX[]) => void;
}

const useLodgeStore = create<LodgeState>((set, get) => ({
  trips: [],
  selectedTrip: null,
  friends: [],
  tripTodos: {},
  setFriends: (friends) => set({ friends }),
  setTrips: (trips) => set({ trips }),
  setSelectedTrip: (trip) => set({ selectedTrip: trip }),
  initializeTripTodos: (trips) => {
    const tripTodos: TripTodosMap = {};
    trips.forEach((trip) => {
      if (trip.trip_todos) {
        tripTodos[trip.id] = [...trip.trip_todos];
      }
    });
    set({ tripTodos });
  },
  addTodo: (tripId, todo) =>
    set((state) => ({
      tripTodos: {
        ...state.tripTodos,
        [tripId]: [...(state.tripTodos[tripId] || []), todo],
      },
    })),
  toggleTodoComplete: (tripId, todoId) =>
    set((state) => ({
      tripTodos: {
        ...state.tripTodos,
        [tripId]:
          state.tripTodos[tripId]?.map((todo) =>
            todo.id === todoId ? { ...todo, completed: !todo.completed } : todo
          ) || [],
      },
    })),
  deleteTodo: (tripId, todoId) =>
    set((state) => ({
      tripTodos: {
        ...state.tripTodos,
        [tripId]:
          state.tripTodos[tripId]?.filter((todo) => todo.id !== todoId) || [],
      },
    })),
  updateTodoId: (tripId, oldId, newId) =>
    set((state) => ({
      tripTodos: {
        ...state.tripTodos,
        [tripId]:
          state.tripTodos[tripId]?.map((todo) =>
            todo.id === oldId ? { ...todo, id: newId } : todo
          ) || [],
      },
    })),
}));

export default useLodgeStore;
